import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {},
  label: {
    display: 'block',
    margin: theme.spacing(2, 0),
  },
}))
